module.exports = __webpack_public_path__ + "fonts/Zen_Maru_Gothic-400-166.1dcdf9d.woff2";